export class LaunchDarklyModel {
    public feature110694addEditDeleteApplications = false;
    public feature112673administrativepagelink = false;
    public feature506985policysearch = false;
    public feature505200mockDataForPolicySearchResultsGrid = false;
    public feature497606nicoratenowLink = false;
  }
export const DefaultLaunchDarklyModel = (): LaunchDarklyModel => new LaunchDarklyModel();
